import queryString from 'query-string'
import 'whatwg-fetch'
import { apiURL } from '../baseURL';
import { _getData, jsonPipe } from './fetch';

const _getNextGame = () => _getData(`${apiURL}ticker`).then(jsonPipe);
const _getCurrentGameInfo = () => _getData(`${apiURL}currentGame`).then(jsonPipe);
const _getLastGameInfo = () => _getData(`${apiURL}lastGame`).then(jsonPipe);
const _getGames = () => _getData(`${apiURL}games?t=${new Date().getMinutes()}`).then(jsonPipe);

export {
    _getNextGame,
    _getGames
}


// WEBPACK FOOTER //
// ./src/Components/Services/Fetch/gameinfo.js